export type WorkstationState = {
  aircraftRegistrations: string[];
  arrivalFrom: string | null;
  arrivalTo: string | null;
  atcCallSigns: string[];
  departureAirports: string[];
  departureFrom: string | null;
  departureGates: string[];
  departureTo: string | null;
  desks: string[];
  destinationAirports: string[];
  destinationGates: string[];
  flightNumbers: string[];
  workstationId: string;
};

export const EMPTY_WORKSTATION_STATE: WorkstationState = {
  aircraftRegistrations: [],
  arrivalFrom: null,
  arrivalTo: null,
  atcCallSigns: [],
  departureAirports: [],
  departureFrom: null,
  departureGates: [],
  departureTo: null,
  desks: [],
  destinationAirports: [],
  destinationGates: [],
  flightNumbers: [],
  workstationId: '',
};
